<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
  >
    <v-img
      :src="image"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <v-list-tile avatar>
          <v-list-tile-avatar
            color="white"
          >
            <v-img
              :src="assets.logo"
              height="34"
              contain
            />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            {{ assets.title }}
          </v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-tile
          v-if="responsive"
        >
          <!-- <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="purple"
          /> -->
        </v-list-tile>
        <v-list-tile
          v-for="(link, i) in links"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState,
  mapGetters
} from 'vuex'
import SearchInput from '../busie/SearchInput'

export default {
  components: {
    'busie-search-input': SearchInput
  },
  data: () => ({
    links: [
      {
        to: '/dashboard',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard'
      },
      {
        to: '/quotes',
        icon: 'mdi-clipboard-outline',
        text: 'Quotes'
      },
      {
        to: '/bookings',
        icon: 'mdi-clipboard-check-outline',
        text: 'Bookings'
      },
      {
        to: '/calendar',
        icon: 'mdi-calendar',
        text: 'Calendar'
      },
      {
        to: '/plan',
        icon: 'mdi-expand-all-outline',
        text: 'Plan'
      },
      {
        to: '/buses',
        icon: 'mdi-bus',
        text: 'Buses'
      },
      // {
      //   to: '/user-profile',
      //   icon: 'mdi-account',
      //   text: 'User Profile'
      // }
    ],
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('operator', ['name', 'logo']),
    assets () {
      return this.isLoggedIn ? {
        logo: this.logo,
        title: this.name
      } : {
        logo: './img/favicon.png',
        title: 'Range by Busie'
      }
    },
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
